<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement data-analysis-page">
		<div class="public_Spacing customerManagementPC">
			<div class="analysis-page-header">
				<div>
					<div class="analysis-page-title">数据分析</div>
					<div class="analysis-page-subtitle">销售排行、充值占比、车辆占比与厂家销量趋势</div>
				</div>
				<div class="analysis-page-badges">
					<span>销售排行</span>
					<span>客户占比</span>
					<span>厂家趋势</span>
				</div>
			</div>

			<el-row class="row-main analysis-grid" :gutter="18">
				<el-col :xs="24" :sm="24" :md="15" :lg="16" :xl="17">
					<el-card class="box-card analysis-card sales-rank-card" shadow="never">
						<div class="analysis-card-header">
							<div>
								<div class="analysis-card-title">销售排行榜</div>
								<div class="analysis-card-desc">点击排行项可快速联动筛选</div>
							</div>
							<button class="public_saleWater_shuaxin pulic_cursor analysis-refresh" @click="shuaxinDataFun()">
								<i class="iconfont icon-shuaxin1"></i>刷新
							</button>
						</div>

						<div class="analysis-filter-panel sales-rank-filter-panel">
							<div class="analysis-filter-group">
								<div class="analysis-filter-item">
									<label class="public_lbSty">客户：</label>
									<el-select @change="changeDatazb1()" :disabled="khSelTs"
										class="public_optionSty dropDown_Define" v-model="customerMo1" placeholder="请选择" filterable remote :remote-method="filterCustomer">
										<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
											:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
										</el-option>
									</el-select>
								</div>
								<div class="analysis-filter-item">
									<label>企业：</label>
									<el-select class="public_optionSty dropDown_Define" :disabled="cjSelTs"
										@change="erpChange1" v-model="enterpriseTwo1" placeholder="请选择" filterable remote :remote-method="filterEnterprise">
										<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
											:label="item.SETTB99CA00" :value="item.SETTB99ID">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="public_operatArea-zdy analysis-date-group">
								<span class="pulic_operatArea_now pulic_cursor"
									:class="dateNowDayActive?'public_dateActive':''" @click="getNowDay">当日</span>
								<span class="public_operatArea_yesterday pulic_cursor"
									:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
								<span class="pulic_operatArea_now pulic_cursor"
									:class="dateNowMonthActive?'public_dateActive':''" @click="sameMonth">当月</span>
								<span class="public_operatArea_yesterday pulic_cursor"
									:class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
								<div class="public_operatArea_timePicker pulic_cursor analysis-date-picker">
									<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange"
										range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
										start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
									</el-date-picker>
								</div>
							</div>
						</div>

						<div class="box sales-rank-list">
							<div class="sales-rank-item" @click="cliFunData(item)" v-for="(item, index) in chartData" :key="index"
								:class="'rank-level-' + (index + 1)">
								<div class="sales-rank-left">
									<div class="rank-index">NO.{{ index + 1 }}</div>
									<div class="rank-name" :title="item.ORMTB410CA00">{{item.ORMTB410CA00}}</div>
								</div>
								<div class="sales-rank-right">
									<div class="rank-value">{{item.ORMTB420CA02}}</div>
									<div class="rank-progress-wrap">
										<div class="barChart rank-progress-chart"></div>
									</div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :xs="24" :sm="24" :md="9" :lg="8" :xl="7">
					<el-card class="box-card analysis-card ratio-card" shadow="never">
						<div class="analysis-card-header ratio-header">
							<div>
								<div class="analysis-card-title">客户占比</div>
								<div class="analysis-card-desc">按客户查看充值与车辆结构</div>
							</div>
						</div>
						<div class="analysis-filter-panel ratio-filter">
							<div class="analysis-filter-item ratio-select">
								<label class="public_lbSty">客户：</label>
								<el-select @change="changeDatazb()" class="public_optionSty dropDown_Define"
									v-model="customerMo" placeholder="请选择" filterable remote :remote-method="filterCustomer">
									<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="ratio-main">
							<div class="ratio-chart-card ratio-recharge-card cz-left">
								<div class="ratio-chart-top">
									<div>
										<div class="ratio-chart-title">充值占比</div>
										<div class="ratio-chart-subtitle">充值金额结构</div>
									</div>
									<span class="ratio-chart-pill">金额</span>
								</div>
								<div id="rechargeRatio" class="ranktext ratio-chart ratio-chart-recharge"></div>
							</div>
							<div class="ratio-chart-card ratio-vehicle-card cl-right">
								<div class="ratio-chart-top">
									<div>
										<div class="ratio-chart-title">车辆占比</div>
										<div class="ratio-chart-subtitle">车辆类型与有效状态结构</div>
									</div>
									<span class="ratio-chart-pill">车辆</span>
								</div>
								<div id="vehicleProportion" class="ranktext ratio-chart ratio-chart-vehicle"></div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<el-row class="row-car-wl-main" :gutter="18">
				<el-col :span="24">
					<el-card class="box-card analysis-card manufacturer-card" shadow="never">
						<div class="wlsj">
							<div class="analysis-card-header manufacturer-header">
								<div>
									<div class="analysis-card-title">厂家销量排行榜</div>
									<div class="analysis-card-desc">展示销售金额、均价、车次与吨数</div>
								</div>
								<div class="manufacturer-filter-wrap">
									<div class="public_operatArea-zdy analysis-date-group">
										<span class="pulic_operatArea_now pulic_cursor"
											:class="dateNowDayActive1?'public_dateActive1':''" @click="getNowDay1">当日</span>
										<span class="public_operatArea_yesterday pulic_cursor"
											:class="dateYesterdayActive1?'public_dateActive1':''" @click="getYesterday1">昨天</span>
										<span class="pulic_operatArea_now pulic_cursor"
											:class="dateNowMonthActive1?'public_dateActive1':''" @click="sameMonth1">当月</span>
										<span class="public_operatArea_yesterday pulic_cursor"
											:class="dateLastMonthActive1?'public_dateActive1':''" @click="lastMonth1">上月</span>
										<div class="public_operatArea_timePicker pulic_cursor analysis-date-picker">
											<el-date-picker v-model="date1" value-format="yyyy-MM-dd" type="daterange"
												range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange1"
												start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
											</el-date-picker>
										</div>
									</div>
									<div class="analysis-filter-item manufacturer-select">
										<label>企业：</label>
										<el-select class="public_optionSty dropDown_Define" @change="erpChange"
											v-model="enterpriseTwo" filterable remote :remote-method="filterEnterprise" placeholder="请选择">
											<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
												:label="item.SETTB99CA00" :value="item.SETTB99ID">
											</el-option>
										</el-select>
									</div>
								</div>
							</div>
							<div class="manufacturer-overview">
								<span class="manufacturer-metric-chip metric-amount">销售金额</span>
								<span class="manufacturer-metric-chip metric-price">均价</span>
								<span class="manufacturer-metric-chip metric-count">车次</span>
								<span class="manufacturer-metric-chip metric-weight">吨数</span>
								<span class="manufacturer-overview-note">横向展示厂家排行，右侧数字固定跟随每一行，拖动侧边滑块查看更多厂家</span>
							</div>
							<div class="wlChart">
								<div id="wlChart" class="manufacturer-chart"></div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import {Decimal} from 'decimal.js';
	import customerSearchMixin from '@/mixins/customerSearchMixin'
	import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
	export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
		data() {
			return {
				customerManagementList: '',
				customerManagementValue: '',
				customerManagement: false,
				customerManagementAdd: false,
				customerManagementAddName: '',
				customerManagemenUPObj: '',
				customerManagementUpdate: false,
				cusQueryName: '',
				cusQueryiphone: '',
				options: [],
				cusStatus: '',
				cusStatusList: [],
				tableData: [],
				flag: '',
				page: 1,
				pagesize: 10,
				currentPage: 1,
				count: 0,
				currentPage1: 1,
				detailsPageLimit: 10,
				detailsCount: 1,
				RechargetypeValue: '',
				RechargetypeOptions: [],
				CZRecordsDetails: [],
				CZRecordsPage: 1,
				CZRecordsPageLimit: 10,
				CZRecordsCount: 0,
				tableDataDetails: [],
				offerDetailsTab: [],
				ORMTB411ID: '',
				CustomerfillingDig: false,

				tabActive: "1",
				scheduleData: [],
				noticesData: [],
				scrollHeight2: 0,
				animate: false,
				timer1: null,
				chartData: [], //销售排行榜
				rechargeRatio: [], //充值占比
				vehicleProportion: [], //车辆占比
				vehiclePieSummary: {
					totalCount: 0,
					validCount: 0,
					invalidCount: 0,
					list: []
				},
				userobj: this.$store.state.uobj,
				customerMo: '', //客户--查询	
				customerMo1: '', //客户--查询	
				khSelTs: false,
				cjSelTs: false,
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				date: [], //日期
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,

				date1: [], //日期
				dateNowDayActive1: false,
				dateYesterdayActive1: false,
				dateNowMonthActive1: false,
				dateLastMonthActive1: false,

				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				enterpriseTwo: '', //二级企业
				enterpriseTwo1: '', //二级企业
				CZmoney: '',
				Czmaxlength: 8, //充值限额
				HCmoney: '',
				HCremark: '',
				HCamountCapitalText: '',
				amountCapitalText: '',
				cusInsertShow: false,
				cusInsertObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				cusUpdateShow: false,
				cusUpdateObj: {
					ORMTB400ID: '',
					ORMTB410CA00: '',
					ORMTB410CA01: '',
					ORMTB410CA02: '',
					ORMTB410CA06: ''
				},
				saleWaterDetails: false,
				rechargeTypeDig: false,
				rechargeTypeName: '',
				rechargeTypeUpOBJ: {
					SETTB206CA01: ''
				},
				rechargeTypeModifyDig: false,
				czRechargetypeShow: false,
				HCshow: false,
				HCObj: '',
				preferentialRecord: false,
				offerDetails: false,
				DetailsWater: false,
				deductionRecord: false,
				deductionRecordObj: '',
				deductionRecordtable: [],
      filteredEnterpriseOptions: [],
				deductionRecordPage: 1,
				deductionRecordLimit: 10,
				deductionRecordCount: 0,
				preferentialType: 0,
				solelist: [],
			};
		},
		created() {
			// 赋值，缓存销毁
			// this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			// sessionStorage.removeItem(this.currentUrl)
			// if (this.historyInfo != null && this.historyInfo != '') {
			// 	this.init()
			// }

			// else {

			// }
		},
		mounted() {
			// if (this.historyInfo == null && this.$route.query.mark == null) {
			// 	this.getNowDay();
			// 	this.getNowDay1();
			// 	this.startTime = this.date[0];
			// 	this.endTime = this.date[1];
			// 	this.startTime1 = this.date1[0];
			// 	this.endTime1 = this.date1[1];
			// 	this.dateNowDayActive = true
			// 	this.dateNowDayActive1 = true
			// }
			this.getNowDay();
			this.getNowDay1();
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.startTime1 = this.date1[0];
			this.endTime1 = this.date1[1];
			this.dateNowDayActive = true
			this.dateNowDayActive1 = true
			// this.querycusList()
			this.queryVehicleProportionList()
			this.queryRechargeRatioList()
			// this.querySelectWLTopTenList()
			this.loadEnterpriseOptions()
			this.loadCustomerOptions()

		},
		// 存储数据
		beforeDestroy() {
			// var obj = {
			// 	startTime: [this.date[0], this.date[1]], //开始时间

			// 	dateNowDayActive: this.dateNowDayActive,
			// 	dateYesterdayActive: this.dateYesterdayActive,
			// 	dateNowMonthActive: this.dateNowMonthActive,
			// 	dateLastMonthActive: this.dateLastMonthActive,

			// 	startTime1: [this.date1[0], this.date1[1]], //开始时间

			// 	dateNowDayActive1: this.dateNowDayActive1,
			// 	dateYesterdayActive1: this.dateYesterdayActive1,
			// 	dateNowMonthActive1: this.dateNowMonthActive1,
			// 	dateLastMonthActive1: this.dateLastMonthActive1,


			// }
			// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			loadCustomerOptions() {
				var postData = {}
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
					postData = { ORMTB400ID: this.userobj.ormtb410.ORMTB410ID }
				}
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
					postData = { ORMTB400ID: this.userobj.ormtb400.ORMTB400ID }
				}
				var List = [{ ORMTB410ID: '', ORMTB410CA00: '全部' }]
				this.axios.post('/orm/ormtb410/selectOrmtb410s', postData).then(res => {
					if (res.data.code == 200) {
						this.customerOptions = [...List, ...res.data.data]
						this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
						this.customerOptionsAll = res.data.data
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
			//初始化数据
			init() {
				this.date = this.historyInfo.startTime
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive

				this.date1 = this.historyInfo.startTime1
				this.dateNowDayActive1 = this.historyInfo.dateNowDayActive1
				this.dateYesterdayActive1 = this.historyInfo.dateYesterdayActive1
				this.dateNowMonthActive1 = this.historyInfo.dateNowMonthActive1
				this.dateLastMonthActive1 = this.historyInfo.dateLastMonthActive1

			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},
			//获取当前时间
			getNowDay1() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date1 = [nowDay, nowDay];
				this.dateNowDayActive1 = true
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},
			datePickerChange1(e) {
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
				this.querycusList()
			},

			//获取昨天时间
			getYesterday1() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date1 = [nowDay, nowDay];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = true
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},

			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
				this.querycusList()
			},
			//获取当月时间
			sameMonth1() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date1 = [firstDay, nextDay];
				this.startTime1 = this.date1[0];
				this.endTime1 = this.date1[1];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = true
				this.dateLastMonthActive1 = false
				this.querySelectWLTopTenList()
			},

			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
				this.querycusList()
			},
			//获取上月时间
			lastMonth1() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date1 = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive1 = false
				this.dateYesterdayActive1 = false
				this.dateNowMonthActive1 = false
				this.dateLastMonthActive1 = true
				this.querySelectWLTopTenList()
			},


			erpChange() {
				this.querySelectWLTopTenList()
				// if (this.enterpriseTwo != '') {
				// 	this.querySelectWLTopTenList()
				// } else {
				// 	// this.materielOptions = [{
				// 	// 	SETTB109CA00: '全部',
				// 	// 	SETTB109ID: '',
				// 	// }]
				// 	this.querySelectWLTopTenList()
				// }
			},
			erpChange1() {
				if (!this.enterpriseTwo1) {
					this.khSelTs = false
				} else {
					this.khSelTs = true
				}
				this.querycusList()

				// if (this.enterpriseTwo != '') {
				// 	this.querySelectWLTopTenList()
				// } else {
				// 	// this.materielOptions = [{
				// 	// 	SETTB109CA00: '全部',
				// 	// 	SETTB109ID: '',
				// 	// }]
				// 	this.querySelectWLTopTenList()
				// }
			},

			cliFunData(row) { //点击查询客销量
				console.log(row)
				if (row.ORMTB410ID) {
					this.customerMo1 = row.ORMTB410ID
					this.cjSelTs = true;
					this.khSelTs = false;
					this.enterpriseTwo1 = '';
					this.querycusList()
				} else {
					this.enterpriseTwo1 = row.ORMTB440CA04
					this.cjSelTs = false;
					this.khSelTs = true;
					this.customerMo1 = '';
					this.querycusList()
				}

			},
			shuaxinDataFun() { //点击从新刷新销售数据排行榜
				this.customerMo1 = '';
				this.enterpriseTwo1 = ''
				this.cjSelTs = false;
				this.khSelTs = false;
				this.querycusList()
			},


			changeDatazb() {
				// console.log(this.customerMo)
				this.queryRechargeRatioList()
				this.queryVehicleProportionList()
			},
			changeDatazb1() {
				// console.log(this.customerMo1)
				if (!this.customerMo1) {
					this.cjSelTs = false
				} else {
					this.cjSelTs = true
				}

				this.querycusList()
			},

			querycusList() { //销售排行榜数据
				var url = "/orm/ormtb420/selectTopTen"
				var postData = {
					startTime: this.date[0], //开始时间
					endTime: this.date[1], //结束时间
					khid: this.customerMo1, //客户id
					qyid: this.enterpriseTwo1 //企业id
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.chartData = res.data.data;
						setTimeout(() => {
							this.barCharts1()
						}, 100)

						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			querySelectWLTopTenList() { //厂家排行榜数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectWLTopTen"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }
				var postData = {
					startTime: this.date1[0], //开始时间
					endTime: this.date1[1], //结束时间
					SETTB99ID: this.enterpriseTwo,
					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.rechargeRatio = res.data.data;
						// console.log(this.rechargeRatio)
						this.wlChartVive(res.data.data.names, res.data.data.values, res.data.data.counts, res.data
							.data.weis)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			queryRechargeRatioList() { //充值占比数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectPie"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }
				var postData = {
					ORMTB410ID: this.customerMo,
					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.rechargeRatio = res.data.data;
						// console.log(this.rechargeRatio)
						this.rankingList(res.data.data)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			queryVehicleProportionList() { //车辆占比数据
				// this.tableData = []
				// this.flag = dataFlag
				// this.count =0
				var url = "/orm/ormtb420/selectCarPie"
				// if(!this.customerMo){
				// 	this.userobj.ormtb400.ORMTB410ID = ''
				// }

				var postData = {
					// ORMTB410ID: this.userobj.ormtb400.ORMTB410ID,
					ORMTB410ID: this.customerMo,

					// ORMTB410CA00: this.cusQueryName, //客户名称
					// ORMTB410CA02: this.cusQueryiphone, //客户名称
					// flag: dataFlag, //查询所有客户全部展示
					// page: this.page,
					// limit: this.pagesize
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// this.vehicleProportion = res.data.data;

						this.vehicleProportionListView(res.data.data)
						// this.count = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			formatCurrency(number) {
			  return new Intl.NumberFormat('zh-CN', {
			    style: 'currency',
			    currency: 'CNY',
			    minimumFractionDigits: 2
			  }).format(number);
			},
			wlChartVive(names, values, counts, weis) { //厂家销量排行榜
				let chartDom = document.getElementById('wlChart')
				let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom)
				var rankColors = [
					['#ffcf5a', '#ff7a45', 'rgba(255, 122, 69, .26)'],
					['#86b6ff', '#2f7df6', 'rgba(47, 125, 246, .24)'],
					['#9adc73', '#20b86f', 'rgba(32, 184, 111, .22)'],
					['#65d8ff', '#2f9df4', 'rgba(47, 157, 244, .18)']
				];
				var visibleEnd = names && names.length > 8 ? Math.ceil(8 / names.length * 100) : 100;
				var reversedNames = (names || []).slice().reverse();
				var reversedValues = (values || []).slice().reverse();
				var reversedCounts = (counts || []).slice().reverse();
				var reversedWeis = (weis || []).slice().reverse();
				var option = {
					backgroundColor: 'transparent',
					tooltip: {
						trigger: 'axis',
						confine: true,
						axisPointer: {
							type: 'shadow',
							shadowStyle: {
								color: 'rgba(64, 158, 255, .08)'
							}
						},
						backgroundColor: 'rgba(31, 45, 61, .94)',
						borderWidth: 0,
						padding: [10, 12],
						textStyle: {
							color: '#fff',
							fontSize: 12,
							lineHeight: 20
						},
						formatter: function(params) {
							var index = params[0].dataIndex;
							var amount = new Intl.NumberFormat().format(reversedValues[index]);
							var average = reversedWeis[index] ? (reversedValues[index] / reversedWeis[index]).toFixed(2) : '0.00';
							return '<b>' + reversedNames[index] + '</b><br/>销售金额：' + amount + ' 元<br/>均价：' + average + '<br/>车次：' + reversedCounts[index] + ' 车<br/>吨数：' + reversedWeis[index] + ' 吨';
						}
					},
					grid: {
						left: 176,
						right: 300,
						bottom: 46,
						top: 28,
						containLabel: false
					},
					xAxis: [{
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							color: '#7b8da3',
							fontSize: 13,
							fontWeight: 'bold',
							formatter: function(value) {
								return value >= 10000 ? value / 10000 + '万' : value;
							}
						},
						splitLine: {
							lineStyle: {
								color: '#e8f0f8',
								type: 'dashed'
							}
						}
					}],
					yAxis: [{
						type: 'category',
						data: reversedNames,
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							color: '#26384d',
							fontSize: 14,
							fontWeight: 'bold',
							lineHeight: 18,
							margin: 14,
							formatter: function(value) {
								if (!value) {
									return '';
								}
								return value.length > 12 ? value.slice(0, 12) + '...' : value;
							}
						}
					}],
					dataZoom: [{
							type: 'slider',
							show: true,
							yAxisIndex: [0],
							right: 16,
							width: 16,
							start: Math.max(0, 100 - visibleEnd),
							end: 100,
							showDetail: false,
							borderColor: 'transparent',
							backgroundColor: '#edf4fb',
							fillerColor: 'rgba(64, 158, 255, .18)',
							handleSize: '88%',
							handleStyle: {
								color: '#409eff',
								shadowBlur: 6,
								shadowColor: 'rgba(64, 158, 255, .26)'
							}
						}, {
							type: 'inside',
							yAxisIndex: [0],
							start: Math.max(0, 100 - visibleEnd),
							end: 100
						}],
					series: [{
						name: '销售金额',
						type: 'bar',
						barWidth: 22,
						barMaxWidth: 28,
						barMinHeight: 8,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(232, 240, 248, .55)',
							barBorderRadius: [0, 999, 999, 0]
						},
						label: {
							show: true,
							distanceToLabelLine: 8,
							position: 'right',
							distance: 12,
							formatter: function(params) {
								var index = params.dataIndex;
								var amount = new Intl.NumberFormat().format(reversedValues[index]);
								var average = reversedWeis[index] ? (reversedValues[index] / reversedWeis[index]).toFixed(2) : '0.00';
								return '{amount|' + amount + ' 元}  {price|' + average + ' 均价}  {count|' + reversedCounts[index] + ' 车}  {weight|' + reversedWeis[index] + ' 吨}';
							},
							rich: {
								amount: {
									color: '#1f4f82',
									fontSize: 15,
									fontWeight: 'bold',
									lineHeight: 24
								},
								price: {
									color: '#168a65',
									fontSize: 13,
									fontWeight: 'bold',
									lineHeight: 24
								},
								count: {
									color: '#2f7df6',
									fontSize: 13,
									fontWeight: 'bold',
									lineHeight: 24
								},
								weight: {
									color: '#7d5cc7',
									fontSize: 13,
									fontWeight: 'bold',
									lineHeight: 24
								}
							}
						},
						itemStyle: {
							barBorderRadius: [0, 999, 999, 0],
							color: function(params) {
								var sourceIndex = reversedValues.length - 1 - params.dataIndex;
								var currentColors = rankColors[sourceIndex] || rankColors[3];
								return new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
									offset: 0,
									color: currentColors[0]
								}, {
									offset: 1,
									color: currentColors[1]
								}]);
							},
							shadowBlur: 8,
							shadowColor: 'rgba(47, 125, 246, .16)'
						},
						emphasis: {
							focus: 'series',
							itemStyle: {
								shadowBlur: 16,
								shadowColor: 'rgba(64, 158, 255, .28)'
							}
						},
						data: reversedValues
					}]
				};

				option && myChart.setOption(option);
			},


			barCharts1() { //销售排行榜
				var a = document.getElementsByClassName('barChart')
				for (var i = 0; i < a.length; i++) {
					var barCharts = echarts.init(a[i]);
					var rankColors = [
						['#ffcf5a', '#ff7a45', 'rgba(255, 122, 69, .36)'],
						['#86b6ff', '#2f7df6', 'rgba(47, 125, 246, .3)'],
						['#9adc73', '#20b86f', 'rgba(32, 184, 111, .28)'],
						['#55d6ff', '#2f9df4', 'rgba(47, 157, 244, .24)'],
					];
					var currentColors = rankColors[i] || rankColors[3];
					var option = {
						backgroundColor: "",
						grid: {
							left: "0", // 距离dom间距
							right: "0",
							top: "10%",
							bottom: "1px",
						},
						xAxis: [{
							show: false,
							type: "value",
							axisPointer: {
								type: "shadow",
							},
							// 横坐标 分割线等取消显示
							axisTick: {
								show: false,
							},
							axisLine: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							axisLabel: {
								show: false,
							},
						}, ],
						yAxis: [{
								//左侧文字
								type: "category",
								inverse: true,
								axisLabel: {
									verticalAlign: "top",
									align: "top",
									padding: [0, 10, 10, 8],
									textStyle: {
										fontSize: 22,
										color: (params) => {
											return '#54dc54';
										},

										fontFamily: "SourceHanSansCN-Regular",
									},
									// textStyle: {
									// 	fontSize: 14,
									// 	color: "#54dc54",
									// 	fontFamily: "SourceHanSansCN-Regular",
									// },
									formatter(value, index) {
										index += 1;
									},
									rich: {
										rank: {
											width: 36,
											height: 10,
											color: "#54dc54",
											align: "center",
											marginRight: 10,
										},
									},
								},
								// 纵坐标数据
								data: this.chartData[i].ORMTB420CA02,
								yAxisIndex: 0,
								// 横坐标 分割线等取消显示
								axisTick: {
									show: false,
								},
								axisLine: {
									show: false,
								},
							},
							{
								//右侧文字
								type: "category",
								inverse: true,
								axisLine: {
									show: false,
								},
								axisTick: {
									show: false,
								},
								axisLabel: {
									show: false,
								},

								data: [this.chartData[i].ORMTB420CA02], //[1000]//myData,
							},
							{
								//左侧柱状图的Y轴
								// gridIndex: 0,//y轴所在的 grid 的索引
								splitLine: "none",
								axisTick: "none",
								axisLine: "none",
								data: [this.chartData[i].ORMTB420CA02],
							},
						],
						series: [

							// {
							// 	//顶层间隔
							// 	show: true,
							// 	type: "pictorialBar",
							// 	symbol: "fixed",
							// 	symbolSize: [0, 10],
							// 	symbolMargin: 10,
							// 	symbolRepeat: "repeat",
							// 	barWidth: 6, // 统计条宽度
							// 	itemStyle: {
							// 		normal: {
							// 			color: "#ec9e00",
							// 		},
							// 	},
							// 	z: 2,
							// 	data: [this.ydata], //[80]//ydata,
							// },
							{
								//中间层
								show: true,
								type: "bar",
								xAxisIndex: 0, //使用的 x 轴的 index，在单个图表实例中存在多个 x 轴的时候有用。
								yAxisIndex: 0, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
								barGap: "-100%",
								barWidth: "10px", // 统计条宽度
								max: 1,
								labelLine: {
									show: false,
								},
								z: 1,
								itemStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
											offset: 0,
											color: currentColors[0]
										}, {
											offset: 1,
											color: currentColors[1]
										}]),
										barBorderRadius: [999, 999, 999, 999],
										shadowBlur: i < 3 ? 8 : 4,
										shadowColor: currentColors[2],
									},
								},
								data: [this.chartData[i].ydata], //[80]//ydata,
							},
							{
								//底层背景
								name: "外框",
								show: true,
								type: "bar",
								xAxisIndex: 0, //使用的 x 轴的 index，在单个图表实例中存在多个 x 轴的时候有用。
								yAxisIndex: 2, //使用的 y 轴的 index，在单个图表实例中存在多个 y 轴的时候有用。
								symbolMargin: 0,
								barGap: "-100%",
								barWidth: 16, // 统计条宽度
								itemStyle: {
									normal: {
										color: "#F3F3F3",
									},
								},
								z: 0,
								data: [100], //[100]//grayBar,
							},
						],
					};
					barCharts.setOption(option);
					barCharts.resize({
						width: "auto",
						height: "20",
					});
				}
			},



			rankingList(data) { //充值金额占比
				let chartDom = document.getElementById('rechargeRatio')
				let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom)
				var option = {
					color: ['#ffb84d', '#ff7a45', '#36cfc9', '#409eff', '#67c23a', '#a78bfa'],
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(31, 45, 61, .92)',
						borderWidth: 0,
						padding: [8, 10],
						textStyle: {
							color: '#fff',
							fontSize: 13,
							fontWeight: 600
						},
						formatter(params) {
							return params.marker + params.name + '<br/>充值金额：' + params.value + '<br/>占比：' + params.percent + '%'
						}
					},
					toolbox: {
						show: true,
						top: 0,
						right: 0,
						itemSize: 12,
						itemGap: 6,
						iconStyle: {
							borderColor: '#aebed0'
						},
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
						}
					},
					legend: {
						type: 'scroll',
						bottom: 14,
						left: 0,
						right: 0,
						height: 30,
						icon: 'circle',
						itemWidth: 9,
						itemHeight: 9,
						itemGap: 8,
						pageIconSize: 8,
						pageButtonGap: 4,
						pageTextStyle: {
							color: '#8a98a8'
						},
						textStyle: {
							color: '#30445c',
							fontSize: 13,
							fontWeight: 600,
							lineHeight: 20,
							padding: [3, 0, 3, 0]
						}
					},
					series: [{
						name: '充值金额',
						type: 'pie',
						radius: ['28%', '46%'],
						center: ['50%', '37%'],
						avoidLabelOverlap: true,
						minAngle: 5,
						minShowLabelAngle: 10,
						hoverOffset: 5,
						itemStyle: {
							borderColor: '#fff',
							borderWidth: 3,
							borderRadius: 6
						},
						label: {
							show: true,
							formatter: '{b}\n{d}%',
							color: '#22344a',
							fontSize: 13,
							fontWeight: 700,
							lineHeight: 16,
							overflow: 'break',
							width: 112
						},
						labelLine: {
							show: true,
							length: 8,
							length2: 4,
							smooth: true,
							lineStyle: {
								color: '#8fa4bb',
								width: 1.4
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 14,
								shadowOffsetX: 0,
								shadowColor: 'rgba(64, 158, 255, .24)'
							}
						},
						data: data,
					}]
				};

				option && myChart.setOption(option);

			},

			vehicleProportionListView(data) { //车辆占比
				let chartDom = document.getElementById('vehicleProportion')
				let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom)
				var pieData = data || {}
				var vehicleList = pieData.list || []
				var totalCount = Number(pieData.totalCount || 0)
				var validCount = Number(pieData.validCount || 0)
				var invalidCount = Number(pieData.invalidCount || 0)
				this.vehiclePieSummary = {
					totalCount: totalCount,
					validCount: validCount,
					invalidCount: invalidCount,
					list: vehicleList.map(item => {
						var value = Number(item.value || 0)
						return {
							name: item.name,
							value: value,
							validCount: Number(item.validCount || 0),
							invalidCount: Number(item.invalidCount || 0),
							percentage: item.percentage != null ? item.percentage : (totalCount ? Number((value / totalCount * 100).toFixed(2)) : 0)
						}
					})
				}
				var statusData = [{
					name: '有效车辆',
					value: validCount,
					itemStyle: {
						color: '#20c997'
					}
				}, {
					name: '无效车辆',
					value: invalidCount,
					itemStyle: {
						color: '#ff7a45'
					}
				}]
				var typeData = this.vehiclePieSummary.list.map((item, index) => {
					return {
						name: item.name,
						value: item.value,
						validCount: item.validCount,
						invalidCount: item.invalidCount,
						percentage: item.percentage,
						itemStyle: {
							color: index === 0 ? '#2f9df4' : '#ffcf5a'
						}
					}
				})
				var option = {
					color: ['#20c997', '#ff7a45', '#2f9df4', '#ffcf5a', '#8b7cf6'],
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(31, 45, 61, .92)',
						borderWidth: 0,
						padding: [8, 10],
						textStyle: {
							color: '#fff',
							fontSize: 13,
							fontWeight: 600
						},
						formatter(params) {
							if (params.seriesName === '车辆类型') {
								return params.marker + params.name +
									'<br/>车辆数量：' + params.value + ' 辆' +
									'<br/>类型占比：' + (params.data.percentage != null ? params.data.percentage : params.percent) + '%' +
									'<br/>有效：' + params.data.validCount + ' 辆' +
									'<br/>无效：' + params.data.invalidCount + ' 辆'
							}
							return params.marker + params.name + '<br/>车辆数量：' + params.value + ' 辆<br/>占比：' + params.percent + '%'
						}
					},
					title: {
						text: String(totalCount),
						subtext: '总车辆',
						left: 'center',
						top: '41%',
						textStyle: {
							color: '#1f2d3d',
							fontSize: 18,
							fontWeight: 800
						},
						subtextStyle: {
							color: '#53677f',
							fontSize: 11,
							fontWeight: 600
						}
					},
					legend: {
						type: 'scroll',
						bottom: -6,
						left: 0,
						right: 0,
						height: 22,
						icon: 'circle',
						itemWidth: 9,
						itemHeight: 9,
						itemGap: 8,
						pageIconSize: 8,
						pageButtonGap: 4,
						pageTextStyle: {
							color: '#8a98a8'
						},
						textStyle: {
							color: '#30445c',
							fontSize: 13,
							fontWeight: 600
						}
					},
					series: [
					{
						name: '有效状态',
						type: 'pie',
						radius: ['25%', '36%'],
						center: ['50%', '48%'],
						avoidLabelOverlap: true,
						minAngle: 5,
						hoverOffset: 4,
						itemStyle: {
							borderColor: '#fff',
							borderWidth: 3,
							borderRadius: 5
						},
						label: {
							show: true,
							formatter: function(params) {
								return params.name + ':' + params.value + '辆'
							},
							color: '#22344a',
							fontSize: 12,
							fontWeight: 700,
							lineHeight: 16,
							overflow: 'break',
							width: 78
						},
						labelLine: {
							show: true,
							length: 10,
							length2: 28,
							smooth: true,
							lineStyle: {
								color: '#8fa4bb',
								width: 1.4
							}
						},
						labelLayout: function(params) {
							return {
								dx: params.dataIndex === 0 ? 96 : -28,
								dy: params.dataIndex === 0 ? 210 : -72
							}
						},
						data: statusData,
					},
					{
						name: '车辆类型',
						type: 'pie',
						radius: ['42%', '55%'],
						center: ['50%', '48%'],
						avoidLabelOverlap: true,
						minAngle: 5,
						minShowLabelAngle: 10,
						hoverOffset: 5,
						itemStyle: {
							borderColor: '#fff',
							borderWidth: 3,
							borderRadius: 6
						},
						label: {
							show: true,
							distanceToLabelLine: 12,
							formatter: function(params) {
								var percentage = params.data.percentage != null ? params.data.percentage : params.percent
								var typeName = params.name || params.data.name || (params.dataIndex === 0 ? '新能源车' : '油车')
								return typeName + '：' + params.value + '辆' +
									'\n' + percentage + '%' +
									'\n有效：' + params.data.validCount + '辆' +
									'\n无效：' + params.data.invalidCount + '辆'
							},
							color: '#22344a',
							fontSize: 12,
							fontWeight: 700,
							lineHeight: 16,
							overflow: 'break',
							width: 156
						},
						labelLayout: {
							hideOverlap: false,
							moveOverlap: 'shiftY',
							dy: function(params) {
								return params.dataIndex === 0 ? -42 : 30
							},
							dx: function(params) {
								return params.dataIndex === 0 ? -24 : 8
							}
						},
						labelLine: {
							show: true,
							length: 18,
							length2: 14,
							smooth: true,
							lineStyle: {
								color: '#8fa4bb',
								width: 1.4
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 14,
								shadowOffsetX: 0,
								shadowColor: 'rgba(32, 201, 151, .24)'
							}
						},
						data: typeData,
					}]
				};
				option && myChart.setOption(option, true);

			}




		}
	};
</script>

<style scoped>
	.data-analysis-page {
		min-height: 100%;
		overflow: hidden;
		background: linear-gradient(180deg, #edf4ff 0%, #f5f8fc 44%, #f7f9fc 100%);
		color: #1f2d3d;
	}

	.customerManagementPC {
		width: 100%;
		min-height: 100%;
		box-sizing: border-box;
		padding: 16px;
		overflow-y: auto;
		overflow-x: hidden;
		background: transparent;
	}

	.analysis-page-header {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 18px;
		margin-bottom: 16px;
		padding: 20px 24px;
		overflow: hidden;
		border: 1px solid rgba(210, 224, 245, 0.88);
		border-radius: 20px;
		background:
			radial-gradient(circle at 86% 12%, rgba(64, 158, 255, 0.18), transparent 30%),
			linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(236, 246, 255, 0.94));
		box-shadow: 0 16px 42px rgba(35, 69, 113, 0.09);
	}

	.analysis-page-header::before {
		position: absolute;
		top: -36px;
		right: 180px;
		width: 150px;
		height: 150px;
		content: '';
		border-radius: 50%;
		background: rgba(102, 177, 255, 0.1);
	}

	.analysis-page-title {
		position: relative;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.35;
		letter-spacing: 1px;
		color: #1b2d45;
	}

	.analysis-page-subtitle {
		position: relative;
		margin-top: 6px;
		font-size: 13px;
		line-height: 1.6;
		color: #6b7c8f;
	}

	.analysis-page-badges {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		gap: 8px;
	}

	.analysis-page-badges span {
		display: inline-flex;
		align-items: center;
		height: 30px;
		padding: 0 14px;
		font-size: 13px;
		font-weight: 600;
		color: #2470be;
		white-space: nowrap;
		border: 1px solid rgba(64, 158, 255, 0.2);
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.82);
	}

	.analysis-grid {
		display: flex;
		align-items: stretch;
	}

	.analysis-grid > .el-col {
		display: flex;
		float: none;
	}

	.analysis-grid .analysis-card {
		width: 100%;
	}

	.row-car-wl-main {
		margin-top: 18px;
	}

	.analysis-card {
		height: 100%;
		border: 0;
		border-radius: 18px;
		background: rgba(255, 255, 255, 0.98);
		box-shadow: 0 14px 34px rgba(31, 69, 112, 0.08);
	}

	.analysis-card >>> .el-card__body {
		box-sizing: border-box;
		height: 100%;
		padding: 18px 20px;
	}

	.sales-rank-card,
	.ratio-card {
		height: 800px;
		max-height: 800px;
	}

	.analysis-card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 14px;
		margin-bottom: 16px;
	}

	.analysis-card-title {
		position: relative;
		padding-left: 12px;
		font-size: 17px;
		font-weight: 700;
		line-height: 1.35;
		color: #24364b;
	}

	.analysis-card-title::before {
		position: absolute;
		top: 4px;
		left: 0;
		width: 4px;
		height: 16px;
		content: '';
		border-radius: 999px;
		background: linear-gradient(180deg, #409eff, #67c23a);
	}

	.analysis-card-desc {
		margin-top: 5px;
		font-size: 12px;
		line-height: 1.5;
		color: #8a98a8;
	}

	.analysis-refresh {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		height: 34px;
		padding: 0 14px;
		font-size: 13px;
		font-weight: 600;
		color: #fff;
		border: 0;
		border-radius: 999px;
		background: linear-gradient(135deg, #2f89f4, #44b4ff);
		box-shadow: 0 8px 18px rgba(64, 158, 255, 0.28);
		transition: transform 0.18s ease, box-shadow 0.18s ease;
	}

	.analysis-refresh:hover {
		transform: translateY(-1px);
		box-shadow: 0 10px 22px rgba(64, 158, 255, 0.36);
	}

	.analysis-filter-panel {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		box-sizing: border-box;
		margin-bottom: 16px;
		padding: 12px;
		border: 1px solid #e6edf7;
		border-radius: 16px;
		background: linear-gradient(135deg, #f9fbff, #f4f9ff);
	}

	.sales-rank-filter-panel {
		align-items: center;
		justify-content: flex-start;
		gap: 14px;
		flex-wrap: wrap;
	}

	.sales-rank-filter-panel .analysis-filter-group,
	.sales-rank-filter-panel .analysis-date-group {
		align-items: center;
		min-height: 34px;
	}

	.sales-rank-filter-panel .analysis-filter-item {
		min-width: auto;
	}

	.sales-rank-filter-panel .analysis-filter-item label,
	.sales-rank-filter-panel .analysis-filter-item .public_lbSty {
		display: inline-flex;
		align-items: center;
		height: 32px;
		line-height: 32px;
	}

	.sales-rank-filter-panel .analysis-filter-item >>> .el-select {
		width: 190px;
	}

	.sales-rank-filter-panel .analysis-filter-item >>> .el-input__inner {
		height: 32px;
		line-height: 32px;
	}

	.sales-rank-filter-panel .analysis-date-picker {
		display: inline-flex;
		align-items: center;
	}

	.sales-rank-filter-panel .analysis-date-picker >>> .el-date-editor {
		height: 32px;
		line-height: 32px;
	}

	.analysis-filter-group,
	.manufacturer-filter-wrap {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
	}

	.manufacturer-filter-wrap {
		justify-content: flex-end;
		box-sizing: border-box;
		padding: 10px 12px;
		border: 1px solid #e3edf8;
		border-radius: 16px;
		background: rgba(255, 255, 255, .78);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9);
	}

	.analysis-filter-item {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 220px;
	}

	.analysis-filter-item label,
	.analysis-filter-item .public_lbSty {
		width: auto;
		margin: 0;
		font-size: 13px;
		font-weight: 600;
		color: #52616f;
		white-space: nowrap;
	}

	.analysis-filter-item >>> .el-select,
	.manufacturer-select >>> .el-select {
		width: 210px;
	}

	.ratio-select,
	.ratio-select >>> .el-select {
		width: 100%;
	}

	.analysis-filter-item >>> .el-input__inner,
	.analysis-date-picker >>> .el-input__inner,
	.analysis-date-picker >>> .el-range-input {
		font-size: 13px;
	}

	.analysis-filter-item >>> .el-input__inner,
	.analysis-date-picker >>> .el-date-editor {
		border-color: #dfe8f4;
		border-radius: 10px;
		background: #fff;
	}

	.public_operatArea-zdy {
		display: flex;
		align-items: center;
		flex-flow: wrap;
		gap: 8px;
		box-sizing: border-box;
	}

	.analysis-date-group > span {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 58px;
		height: 32px;
		padding: 0 13px;
		font-size: 13px;
		font-weight: 600;
		color: #596a7c;
		border: 1px solid #dfe8f4;
		border-radius: 999px;
		background: #fff;
		transition: all 0.18s ease;
	}

	.analysis-date-group > span:hover {
		color: #2470be;
		border-color: rgba(64, 158, 255, 0.42);
		background: #edf6ff;
	}

	.public_dateActive,
	.public_dateActive1 {
		color: #fff !important;
		border-color: transparent !important;
		background: linear-gradient(135deg, #2f89f4, #3db7ff) !important;
		box-shadow: 0 8px 16px rgba(64, 158, 255, 0.26);
	}

	.analysis-date-picker >>> .el-date-editor {
		width: 258px;
		height: 32px;
		line-height: 32px;
	}

	.sales-rank-card >>> .el-card__body {
		display: flex;
		flex-direction: column;
	}

	.sales-rank-list {
		display: flex;
		flex: 1;
		min-height: 0;
		flex-direction: column;
		gap: 10px;
		padding: 8px 6px 4px;
		overflow: auto;
		box-sizing: border-box;
	}

	.sales-rank-item {
		position: relative;
		display: grid;
		grid-template-columns: minmax(190px, 260px) minmax(320px, 1fr);
		align-items: center;
		gap: 16px;
		min-height: 56px;
		padding: 10px 14px;
		overflow: hidden;
		border: 1px solid #e7eef8;
		border-radius: 16px;
		background:
			linear-gradient(135deg, rgba(255, 255, 255, .96), rgba(247, 251, 255, .96)),
			radial-gradient(circle at 98% 0%, rgba(64, 158, 255, .12), transparent 32%);
		box-shadow: 0 8px 20px rgba(44, 86, 132, .06);
		cursor: pointer;
		transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
	}

	.sales-rank-item::before {
		position: absolute;
		left: 0;
		top: 12px;
		bottom: 12px;
		width: 4px;
		content: '';
		border-radius: 0 999px 999px 0;
		background: linear-gradient(180deg, #409eff, #67c23a);
	}

	.sales-rank-item:hover {
		border-color: rgba(64, 158, 255, .35);
		box-shadow: 0 12px 28px rgba(44, 86, 132, .11);
		transform: translateX(3px);
	}

	.sales-rank-left {
		display: flex;
		align-items: center;
		gap: 12px;
		min-width: 0;
	}

	.sales-rank-right {
		display: grid;
		grid-template-columns: minmax(90px, max-content) 1fr;
		align-items: center;
		gap: 14px;
		min-width: 0;
	}

	.rank-level-1 {
		border-color: rgba(245, 166, 35, 0.38);
		background: linear-gradient(135deg, #fff7e8, #fffdf8);
	}

	.rank-level-1::before {
		background: linear-gradient(180deg, #f5a623, #ffcf5a);
	}

	.rank-level-2 {
		border-color: rgba(88, 144, 255, 0.32);
		background: linear-gradient(135deg, #eef5ff, #fbfdff);
	}

	.rank-level-2::before {
		background: linear-gradient(180deg, #5890ff, #86b6ff);
	}

	.rank-level-3 {
		border-color: rgba(103, 194, 58, 0.32);
		background: linear-gradient(135deg, #eefaf0, #fbfefb);
	}

	.rank-level-3::before {
		background: linear-gradient(180deg, #67c23a, #9adc73);
	}

	.rank-index {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 auto;
		min-width: 58px;
		height: 30px;
		padding: 0 10px;
		font-size: 12px;
		font-weight: 900;
		letter-spacing: 0.6px;
		color: #2470be;
		border-radius: 999px;
		background: rgba(64, 158, 255, .1);
	}

	.rank-name {
		min-width: 0;
		overflow: hidden;
		font-size: 15px;
		font-weight: 800;
		color: #26384d;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.rank-value {
		min-width: 86px;
		font-size: 16px;
		font-weight: 900;
		color: #1f79d8;
		text-align: right;
		white-space: nowrap;
	}

	.rank-progress-wrap {
		position: relative;
		min-width: 0;
		padding: 7px 10px;
		border-radius: 999px;
		background: #f1f6fd;
	}

	.rank-progress-chart,
	.barChart {
		width: 100%;
		height: 28px;
	}

	.ratio-card >>> .el-card__body {
		display: flex;
		flex-direction: column;
		background:
			radial-gradient(circle at 100% 8%, rgba(64, 158, 255, .08), transparent 30%),
			radial-gradient(circle at 0% 42%, rgba(32, 218, 156, .08), transparent 28%);
	}

	.ratio-header {
		margin-bottom: 12px;
	}

	.ratio-filter {
		justify-content: flex-start;
		margin-bottom: 12px;
		padding: 10px 12px;
		border-color: #e2edf7;
		background: rgba(255, 255, 255, .78);
	}

	.ratio-select {
		min-width: 0;
	}

	.ratio-select >>> .el-select {
		width: 100%;
		min-width: 180px;
	}

	.ratio-main {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
		gap: 10px;
		width: 100%;
		flex: 1;
		min-height: 0;
	}

	.ratio-chart-card {
		position: relative;
		display: grid;
		box-sizing: border-box;
		min-height: 0;
		padding: 12px;
		overflow: visible;
		grid-template-rows: auto minmax(260px, 1fr);
		border: 1px solid #e1ebf6;
		border-radius: 18px;
		background:
			linear-gradient(145deg, rgba(255, 255, 255, .96), rgba(247, 251, 255, .94)),
			repeating-linear-gradient(135deg, rgba(64, 158, 255, .045) 0, rgba(64, 158, 255, .045) 1px, transparent 1px, transparent 18px);
		box-shadow: 0 10px 24px rgba(46, 89, 132, .07);
	}

	.ratio-chart-card::before {
		position: absolute;
		inset: 0 auto 0 0;
		width: 4px;
		content: '';
		background: linear-gradient(180deg, #ffb84d, #409eff);
	}

	.ratio-chart-card::after {
		position: absolute;
		right: -38px;
		bottom: -52px;
		width: 128px;
		height: 128px;
		content: '';
		border-radius: 50%;
		background: rgba(64, 158, 255, 0.08);
	}

	.ratio-vehicle-card::before {
		background: linear-gradient(180deg, #20c997, #2f9df4);
	}

	.ratio-vehicle-card::after {
		background: rgba(32, 201, 151, 0.09);
	}

	.ratio-vehicle-card {
		grid-template-rows: auto minmax(220px, 1fr);
	}

	.ratio-chart-top {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 10px;
	}

	.ratio-chart-title {
		font-size: 15px;
		font-weight: 800;
		line-height: 1.35;
		color: #25384d;
	}

	.ratio-chart-subtitle {
		margin-top: 4px;
		font-size: 12px;
		color: #8a98a8;
	}

	.ratio-chart-pill {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 42px;
		height: 24px;
		padding: 0 9px;
		font-size: 12px;
		font-weight: 800;
		color: #2470be;
		border-radius: 999px;
		background: rgba(64, 158, 255, .1);
	}

	.ratio-vehicle-card .ratio-chart-pill {
		color: #168a65;
		background: rgba(32, 201, 151, .12);
	}

	.ratio-chart {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		min-height: 260px;
	}

	.ratio-chart-vehicle {
		min-height: 250px;
	}

	.wlsj {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.manufacturer-card >>> .el-card__body {
		background:
			radial-gradient(circle at 96% 6%, rgba(255, 184, 77, .12), transparent 28%),
			radial-gradient(circle at 4% 100%, rgba(64, 158, 255, .11), transparent 30%);
	}

	.manufacturer-header {
		align-items: center;
		margin-bottom: 12px;
	}

	.manufacturer-select {
		min-width: 220px;
	}

	.manufacturer-overview {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 9px;
		box-sizing: border-box;
		margin-bottom: 12px;
		padding: 12px 14px;
		border: 1px solid #e5eef7;
		border-radius: 18px;
		background:
			linear-gradient(135deg, rgba(255, 255, 255, .9), rgba(247, 251, 255, .86)),
			repeating-linear-gradient(90deg, rgba(64, 158, 255, .04) 0, rgba(64, 158, 255, .04) 1px, transparent 1px, transparent 30px);
	}

	.manufacturer-metric-chip {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 28px;
		padding: 0 12px;
		font-size: 13px;
		font-weight: 800;
		border-radius: 999px;
		white-space: nowrap;
	}

	.metric-amount {
		color: #c96b1d;
		background: rgba(255, 184, 77, .16);
	}

	.metric-price {
		color: #148461;
		background: rgba(32, 201, 151, .14);
	}

	.metric-count {
		color: #2470be;
		background: rgba(64, 158, 255, .13);
	}

	.metric-weight {
		color: #7d5cc7;
		background: rgba(139, 124, 246, .13);
	}

	.manufacturer-overview-note {
		font-size: 12px;
		color: #8797aa;
		line-height: 1.6;
	}

	.wlChart {
		position: relative;
		box-sizing: border-box;
		height: 600px;
		padding: 18px 16px 10px;
		overflow: hidden;
		border: 1px solid #dfeaf6;
		border-radius: 22px;
		background:
			linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 255, 0.96)),
			repeating-linear-gradient(90deg, rgba(64, 158, 255, 0.05) 0, rgba(64, 158, 255, 0.05) 1px, transparent 1px, transparent 44px),
			repeating-linear-gradient(0deg, rgba(32, 201, 151, 0.035) 0, rgba(32, 201, 151, 0.035) 1px, transparent 1px, transparent 36px);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 14px 30px rgba(45, 95, 146, .07);
	}

	.wlChart::before {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 4px;
		content: '';
		background: linear-gradient(90deg, #ffcf5a, #409eff, #20c997);
	}

	.wlChart::after {
		position: absolute;
		right: -54px;
		bottom: -70px;
		width: 180px;
		height: 180px;
		content: '';
		border-radius: 50%;
		background: rgba(64, 158, 255, .08);
	}

	.manufacturer-chart {
		position: relative;
		z-index: 1;
		width: 100%;
		height: 100%;
		min-height: 520px;
	}

	.selected-right {
		text-align: center;
	}

	@media screen and (max-width: 1500px) {
		.analysis-page-title {
			font-size: 22px;
		}

		.sales-rank-card,
		.ratio-card {
			height: 800px;
			max-height: 800px;
		}

		.sales-rank-list {
			min-height: 0;
		}

		.ratio-chart-card {
			min-height: 0;
		}

		.ratio-chart {
			height: 100%;
			min-height: 0;
		}

		.wlChart {
			height: 560px;
		}

		.manufacturer-chart {
			min-height: 480px;
		}
	}

	@media screen and (max-width: 1200px) {
		.analysis-card >>> .el-card__body {
			padding: 16px;
		}

		.analysis-filter-panel {
			align-items: flex-start;
			justify-content: flex-start;
		}

		.analysis-filter-group {
			width: 100%;
		}

		.analysis-filter-item {
			flex: 1 1 220px;
		}

		.analysis-filter-item >>> .el-select,
		.manufacturer-select >>> .el-select {
			width: 100%;
		}

		.sales-rank-list {
			grid-template-columns: 190px minmax(320px, 1fr);
		}

		.manufacturer-filter-wrap {
			width: 100%;
			justify-content: flex-start;
		}

		.manufacturer-overview {
			align-items: flex-start;
		}

		.manufacturer-overview-note {
			flex: 1 1 100%;
		}

		.wlChart {
			height: 510px;
		}
	}

	@media screen and (max-width: 768px) {
		.customerManagementPC {
			padding: 12px;
		}

		.analysis-page-header {
			align-items: flex-start;
			flex-direction: column;
			padding: 16px;
		}

		.analysis-page-badges {
			justify-content: flex-start;
		}

		.analysis-card-header,
		.manufacturer-header {
			align-items: flex-start;
			flex-direction: column;
		}

		.analysis-filter-panel {
			padding: 10px;
		}

		.analysis-filter-item {
			min-width: 100%;
		}

		.analysis-date-group {
			width: 100%;
		}

		.analysis-date-group > span {
			flex: 1 1 calc(50% - 8px);
		}

		.analysis-date-picker,
		.analysis-date-picker >>> .el-date-editor {
			width: 100%;
		}

		.sales-rank-card,
		.ratio-card {
			height: auto;
			max-height: none;
		}

		.sales-rank-list {
			min-height: 0;
		}

		.ratio-chart-card {
			min-height: 0;
		}

		.ratio-chart {
			height: 100%;
			min-height: 0;
		}

		.wlChart {
			height: 440px;
			padding: 12px 6px 8px;
		}

		.manufacturer-overview {
			padding: 10px;
		}

		.manufacturer-metric-chip {
			flex: 1 1 calc(50% - 9px);
		}

		.manufacturer-chart {
			min-height: 390px;
		}
	}

	@media screen and (max-width: 520px) {
		.analysis-page-title {
			font-size: 20px;
		}

		.analysis-page-badges span {
			flex: 1 1 auto;
			justify-content: center;
		}

		.analysis-refresh {
			width: 100%;
		}

		.sales-rank-list {
			min-height: 120px;
		}
	}
</style>
